module.exports = "query Tags ($page: Int = 1, $limit: Int = 10000, $asc: String, $desc: String, $status: String, $in_media: Boolean = false) {\n  tags (page: $page, limit: $limit, asc: $asc, desc: $desc, status: $status, in_media: $in_media) {\n    data {\n      id\n      name\n      slug\n      status\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Tags.graphql
// module id = 44RW
// module chunks = 1624